export default __webpack_public_path__ + "static/media/downloadIOS.e6a28855.webp";